export default "__VITE_ASSET__bbd22f34__"